"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractDurationType = exports.WorkingTimeType = exports.SearchFilterOptionGroup = exports.WorkingTimeTypeMap = exports.hourBaseByOfferTypeMap = exports.OfferContractDurationType = exports.HourBase = exports.SalaryRate = exports.EContractType = exports.EOfferType = exports.offerTypeMap = exports.EOfferGalleryKey = exports.EOfferAssetsFormField = exports.EOfferBasicInfoFormField = exports.EOfferPaymentTypeFormField = exports.SalaryType = exports.OfferAction = exports.OfferPaymentType = exports.EOfferStep = exports.SalaryCurrency = exports.SendType = exports.OfferTypeId = void 0;
var OfferTypeId;
(function (OfferTypeId) {
    OfferTypeId[OfferTypeId["internship"] = 1] = "internship";
    OfferTypeId[OfferTypeId["permanent"] = 2] = "permanent";
    OfferTypeId[OfferTypeId["volunteering"] = 3] = "volunteering";
    OfferTypeId[OfferTypeId["temporaryJob"] = 4] = "temporaryJob";
    OfferTypeId[OfferTypeId["workAndTravel"] = 5] = "workAndTravel";
    OfferTypeId[OfferTypeId["contractor"] = 6] = "contractor";
})(OfferTypeId || (exports.OfferTypeId = OfferTypeId = {}));
const offerTypeMap = {
    sk: {
        staz: OfferTypeId.internship,
        praca: OfferTypeId.permanent,
        dobrovolnictvo: OfferTypeId.volunteering,
        brigada: OfferTypeId.temporaryJob,
        'work-and-travel': OfferTypeId.workAndTravel,
        zivnost: OfferTypeId.contractor,
    },
    en: {
        internship: OfferTypeId.internship,
        permanent: OfferTypeId.permanent,
        volunteering: OfferTypeId.volunteering,
        'temporary-job': OfferTypeId.temporaryJob,
        'work-and-travel': OfferTypeId.workAndTravel,
        contractor: OfferTypeId.contractor,
    },
};
exports.offerTypeMap = offerTypeMap;
const WorkingTimeTypeMap = {
    sk: {
        flexible: 'Flexibilná',
        fix: 'Fixná',
    },
    en: {
        flexible: 'Flexible',
        fix: 'Fix',
    },
};
exports.WorkingTimeTypeMap = WorkingTimeTypeMap;
var SendType;
(function (SendType) {
    SendType["rejected"] = "rejected";
    SendType["rejected_and_accepted"] = "rejected_and_accepted";
})(SendType || (exports.SendType = SendType = {}));
var OfferContractDurationType;
(function (OfferContractDurationType) {
    OfferContractDurationType["day"] = "day";
    OfferContractDurationType["week"] = "week";
    OfferContractDurationType["month"] = "month";
    OfferContractDurationType["year"] = "year";
})(OfferContractDurationType || (exports.OfferContractDurationType = OfferContractDurationType = {}));
var EOfferType;
(function (EOfferType) {
    EOfferType[EOfferType["internship"] = 1] = "internship";
    EOfferType[EOfferType["permanent"] = 2] = "permanent";
    EOfferType[EOfferType["volunteering"] = 3] = "volunteering";
    EOfferType[EOfferType["temporary_job"] = 4] = "temporary_job";
    EOfferType[EOfferType["work_and_travel"] = 5] = "work_and_travel";
    EOfferType[EOfferType["contractor"] = 6] = "contractor";
})(EOfferType || (exports.EOfferType = EOfferType = {}));
var EContractType;
(function (EContractType) {
    EContractType[EContractType["full_time"] = 1] = "full_time";
    EContractType[EContractType["part_time"] = 2] = "part_time";
})(EContractType || (exports.EContractType = EContractType = {}));
var HourBase;
(function (HourBase) {
    HourBase[HourBase["full_time"] = 160] = "full_time";
    HourBase[HourBase["part_time"] = 80] = "part_time";
})(HourBase || (exports.HourBase = HourBase = {}));
const hourBaseByOfferTypeMap = {
    [EOfferType.permanent]: {
        [EContractType.full_time]: HourBase.full_time,
        [EContractType.part_time]: HourBase.part_time,
    },
    [EOfferType.internship]: HourBase.part_time,
    [EOfferType.temporary_job]: HourBase.part_time,
    [EOfferType.contractor]: HourBase.full_time,
    [EOfferType.work_and_travel]: HourBase.full_time,
};
exports.hourBaseByOfferTypeMap = hourBaseByOfferTypeMap;
var SalaryRate;
(function (SalaryRate) {
    SalaryRate["hourly"] = "hourly";
    SalaryRate["monthly"] = "monthly";
    SalaryRate["once"] = "once";
})(SalaryRate || (exports.SalaryRate = SalaryRate = {}));
var SalaryCurrency;
(function (SalaryCurrency) {
    SalaryCurrency["euro"] = "\u20AC";
})(SalaryCurrency || (exports.SalaryCurrency = SalaryCurrency = {}));
var EOfferStep;
(function (EOfferStep) {
    EOfferStep[EOfferStep["PAYMENT_TYPE"] = 0] = "PAYMENT_TYPE";
    EOfferStep[EOfferStep["BASIC_INFO"] = 1] = "BASIC_INFO";
    EOfferStep[EOfferStep["ASSETS"] = 2] = "ASSETS";
    EOfferStep[EOfferStep["PREVIEW"] = 3] = "PREVIEW";
})(EOfferStep || (exports.EOfferStep = EOfferStep = {}));
var OfferPaymentType;
(function (OfferPaymentType) {
    OfferPaymentType["PAY_WITH_OFFER_CREDITS"] = "PAY_WITH_OFFER_CREDITS";
    OfferPaymentType["PAY_PER_APPLICATION"] = "PAY_PER_APPLICATION";
})(OfferPaymentType || (exports.OfferPaymentType = OfferPaymentType = {}));
var OfferAction;
(function (OfferAction) {
    OfferAction["edit"] = "edit";
    OfferAction["create"] = "create";
})(OfferAction || (exports.OfferAction = OfferAction = {}));
var SalaryType;
(function (SalaryType) {
    SalaryType["net"] = "net";
    SalaryType["gross"] = "gross";
})(SalaryType || (exports.SalaryType = SalaryType = {}));
var EOfferPaymentTypeFormField;
(function (EOfferPaymentTypeFormField) {
    EOfferPaymentTypeFormField["paymentType"] = "paymentType";
    EOfferPaymentTypeFormField["billingProfileId"] = "billingProfileId";
})(EOfferPaymentTypeFormField || (exports.EOfferPaymentTypeFormField = EOfferPaymentTypeFormField = {}));
var EOfferBasicInfoFormField;
(function (EOfferBasicInfoFormField) {
    EOfferBasicInfoFormField["title"] = "title";
    EOfferBasicInfoFormField["redirectUrl"] = "redirectUrl";
    EOfferBasicInfoFormField["offerTypeId"] = "offerTypeId";
    EOfferBasicInfoFormField["homeOffice"] = "homeOffice";
    EOfferBasicInfoFormField["jobArea"] = "jobArea";
    EOfferBasicInfoFormField["description"] = "description";
    EOfferBasicInfoFormField["required"] = "required";
    EOfferBasicInfoFormField["niceToHave"] = "niceToHave";
    EOfferBasicInfoFormField["deadline"] = "deadline";
    EOfferBasicInfoFormField["isPaid"] = "isPaid";
    EOfferBasicInfoFormField["benefits"] = "benefits";
    EOfferBasicInfoFormField["durationMin"] = "durationMin";
    EOfferBasicInfoFormField["durationMax"] = "durationMax";
    EOfferBasicInfoFormField["durationType"] = "durationType";
    EOfferBasicInfoFormField["contractTypeId"] = "contractTypeId";
    EOfferBasicInfoFormField["salaryRate"] = "salaryRate";
    EOfferBasicInfoFormField["salaryAmountFrom"] = "salaryAmountFrom";
    EOfferBasicInfoFormField["salaryAmountTo"] = "salaryAmountTo";
    EOfferBasicInfoFormField["salaryCurrency"] = "salaryCurrency";
    EOfferBasicInfoFormField["salaryDescription"] = "salaryDescription";
    EOfferBasicInfoFormField["salaryType"] = "salaryType";
    EOfferBasicInfoFormField["resumeRequired"] = "resumeRequired";
    EOfferBasicInfoFormField["motivationalRequired"] = "motivationalRequired";
    EOfferBasicInfoFormField["address"] = "address";
    EOfferBasicInfoFormField["contact_email"] = "contact_email";
    EOfferBasicInfoFormField["turnUpDate"] = "turnUpDate";
    EOfferBasicInfoFormField["turnUpDateAsap"] = "turnUpDateAsap";
    EOfferBasicInfoFormField["languages"] = "languages";
    EOfferBasicInfoFormField["languageCode"] = "languageCode";
    EOfferBasicInfoFormField["languageLevel"] = "languageLevel";
    EOfferBasicInfoFormField["driverLicences"] = "driverLicences";
    EOfferBasicInfoFormField["driverLicence"] = "driverLicence";
    EOfferBasicInfoFormField["mileage"] = "mileage";
    EOfferBasicInfoFormField["workingTimeFrom"] = "workingTimeFrom";
    EOfferBasicInfoFormField["workingTimeTo"] = "workingTimeTo";
    EOfferBasicInfoFormField["workingTimeHours"] = "workingTimeHours";
    EOfferBasicInfoFormField["workingTimeType"] = "workingTimeType";
    EOfferBasicInfoFormField["workingTimeInfo"] = "workingTimeInfo";
    EOfferBasicInfoFormField["skillTags"] = "skillTags";
    EOfferBasicInfoFormField["rateSkillTagsSwitch"] = "rateSkillTagsSwitch";
    EOfferBasicInfoFormField["skillTagsRates"] = "skillTagsRates";
    EOfferBasicInfoFormField["timezone"] = "timezone";
    EOfferBasicInfoFormField["isIndefinite"] = "isIndefinite";
})(EOfferBasicInfoFormField || (exports.EOfferBasicInfoFormField = EOfferBasicInfoFormField = {}));
var EOfferAssetsFormField;
(function (EOfferAssetsFormField) {
    EOfferAssetsFormField["galleries"] = "galleries";
})(EOfferAssetsFormField || (exports.EOfferAssetsFormField = EOfferAssetsFormField = {}));
var EOfferGalleryKey;
(function (EOfferGalleryKey) {
    EOfferGalleryKey["title"] = "title";
    EOfferGalleryKey["isTitleGallery"] = "isTitleGallery";
    EOfferGalleryKey["uuid"] = "uuid";
    EOfferGalleryKey["assets"] = "assets";
})(EOfferGalleryKey || (exports.EOfferGalleryKey = EOfferGalleryKey = {}));
var SearchFilterOptionGroup;
(function (SearchFilterOptionGroup) {
    SearchFilterOptionGroup["company"] = "company";
    SearchFilterOptionGroup["skillTag"] = "skillTag";
    SearchFilterOptionGroup["keyword"] = "keyword";
})(SearchFilterOptionGroup || (exports.SearchFilterOptionGroup = SearchFilterOptionGroup = {}));
var WorkingTimeType;
(function (WorkingTimeType) {
    WorkingTimeType["FIX"] = "fix";
    WorkingTimeType["FLEXIBLE"] = "flexible";
})(WorkingTimeType || (exports.WorkingTimeType = WorkingTimeType = {}));
var ContractDurationType;
(function (ContractDurationType) {
    ContractDurationType["definite"] = "definite";
    ContractDurationType["indefinite"] = "indefinite";
})(ContractDurationType || (exports.ContractDurationType = ContractDurationType = {}));
